import type { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { useDeliveryAreasSellarDistribution } from "./useDeliveryAreasSellarDistribution";

export const useOrderDistributionDeliveryArea = ({
  fulfillmentType,
  supplierId,
  postcode,
}: {
  fulfillmentType: OrderGetResponseType["fulfillmentType"] | undefined;
  supplierId: number;
  postcode: string | undefined;
}) => {
  const isDistributionOrder = fulfillmentType === "sellarDistribution";
  const { data } = useDeliveryAreasSellarDistribution(
    { SupplierId: supplierId, postcode },
    { enabled: isDistributionOrder },
  );

  // Disabled queries can still expose cached results for the same supplier and postcode.
  const deliveryArea = isDistributionOrder ? data?.[0] : undefined;

  return {
    deliveryArea,
    usesPalletInbound: deliveryArea?.distributionType === "pallet_inbound",
  };
};
